import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { faqs } from '@/mocks/faq';

const stats = [
  { value: '5000+', label: '爆料资讯' },
  { value: '300万+', label: '月活用户' },
  { value: '50+', label: '合作媒体' },
  { value: '24h', label: '全天候更新' },
];

export default function About() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于黑料网吃瓜',
    description: '黑料网吃瓜是娱乐爱好者获取最新明星爆料、网红黑料、热门瓜的首选平台。汇聚全网最新最劲爆的吃瓜资讯。',
    url: 'https://heiliao.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料网吃瓜',
      url: 'https://heiliao.com',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料网吃瓜',
    url: 'https://heiliao.com',
    description: '汇聚全网最新最劲爆的吃瓜资讯平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'tips@heiliao.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto pb-14">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />

              {/* Page Title */}
              <div className="py-10 text-center">
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                  关于黑料网吃瓜
                </h1>
                <p className="text-sm text-foreground-500 max-w-lg mx-auto leading-relaxed">
                  汇聚全网最新最劲爆的吃瓜资讯，做最懂你的娱乐爆料平台
                </p>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-12">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center p-5 bg-background-50 rounded-lg border border-background-200/70">
                    <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>

              {/* Brand Introduction */}
              <section className="mb-12">
                <h2 className="text-lg font-bold text-foreground-950 mb-5 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-building-2-line text-accent-500"></i>
                  </div>
                  品牌介绍
                </h2>
                <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 space-y-4">
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    <strong>黑料网吃瓜</strong>成立于2024年，是国内领先的娱乐资讯聚合平台。我们致力于为广大娱乐爱好者提供最新、最快、最全的明星爆料、网红黑料、娱乐八卦等吃瓜资讯。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    我们的编辑团队由资深娱乐记者和自媒体人组成，拥有丰富的行业经验和敏锐的新闻嗅觉。我们采用先进的信息聚合技术，实时监测全网各大社交平台和娱乐媒体的最新动态，确保用户能够在第一时间获取到最新鲜的吃瓜内容。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    在内容审核方面，我们始终坚持"真实、客观、有趣"的原则。每一条资讯在发布前都经过多重核实，对于未经证实的爆料，我们会在文章中明确标注信息来源和可信度等级，让用户在吃瓜的同时也能做出理性的判断。
                  </p>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    自上线以来，黑料网吃瓜已经积累了超过300万的月活用户，成为了众多娱乐爱好者每天必刷的吃瓜平台。我们将继续努力，为每一个热爱吃瓜的你提供更好的阅读体验。
                  </p>
                </div>
              </section>

              {/* Reputation */}
              <section className="mb-12">
                <h2 className="text-lg font-bold text-foreground-950 mb-5 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-shield-check-line text-accent-500"></i>
                  </div>
                  平台口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                      <i className="ri-speed-up-line text-accent-500"></i>
                    </div>
                    <h3 className="text-sm font-bold text-foreground-950 mb-2">更新速度快</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      全天候实时监测热点，重大事件5分钟内推送，让你永远快人一步吃到最新鲜的瓜。
                    </p>
                  </div>
                  <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                      <i className="ri-check-double-line text-accent-500"></i>
                    </div>
                    <h3 className="text-sm font-bold text-foreground-950 mb-2">信息可信度高</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      每条资讯经过多重核实，标注可信度等级，让用户吃得放心，瓜得明白。
                    </p>
                  </div>
                  <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                      <i className="ri-user-heart-line text-accent-500"></i>
                    </div>
                    <h3 className="text-sm font-bold text-foreground-950 mb-2">用户体验好</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      简洁清爽的界面设计，智能的内容推荐，让每一次吃瓜都成为一种享受。
                    </p>
                  </div>
                </div>
              </section>

              {/* Contact */}
              <section className="mb-12">
                <h2 className="text-lg font-bold text-foreground-950 mb-5 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-line text-accent-500"></i>
                  </div>
                  联系我们
                </h2>
                <div className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-3">商务合作</h3>
                      <p className="text-sm text-foreground-600 mb-1">邮箱：biz@heiliao.com</p>
                      <p className="text-sm text-foreground-600">我们期待与各大品牌、媒体的合作洽谈</p>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-3">爆料投稿</h3>
                      <p className="text-sm text-foreground-600 mb-1">邮箱：tips@heiliao.com</p>
                      <p className="text-sm text-foreground-600">欢迎提供爆料线索，优质内容有奖</p>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-3">侵权投诉</h3>
                      <p className="text-sm text-foreground-600 mb-1">邮箱：legal@heiliao.com</p>
                      <p className="text-sm text-foreground-600">如发现侵权内容，请及时联系我们处理</p>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-3">工作时间</h3>
                      <p className="text-sm text-foreground-600 mb-1">周一至周五 9:00 - 18:00</p>
                      <p className="text-sm text-foreground-600">法定节假日休息，紧急事务可邮件联系</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* FAQ */}
              <section>
                <h2 className="text-lg font-bold text-foreground-950 mb-5 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-question-line text-accent-500"></i>
                  </div>
                  常见问题
                </h2>
                <div className="space-y-3">
                  {faqs.map((faq, index) => (
                    <details
                      key={index}
                      className="bg-background-50 rounded-lg border border-background-200/70 group cursor-pointer"
                    >
                      <summary className="p-5 text-sm font-medium text-foreground-900 flex items-center justify-between">
                        <span>{faq.question}</span>
                        <div className="w-5 h-5 flex items-center justify-center shrink-0 transition-transform duration-200 group-open:rotate-180">
                          <i className="ri-arrow-down-s-line text-foreground-400"></i>
                        </div>
                      </summary>
                      <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-200/70 pt-4">
                        {faq.answer}
                      </div>
                    </details>
                  ))}
                </div>
              </section>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}